import { EManualMatchingStatus, EProcessStatus } from '@enums/campaign-analytics.enum';
import { ICampaignExportApi } from '@pages/campaigns/campaign-details/campaign-details-banner/campaign-export-dialog/campaign-export-dialog.interface';

export { EManualMatchingStatus };

export enum EManualMatchingStatusAction {
  markAsMatched = 'matched',
  markAsUnmatched = 'unmatched',
  remove = 0,
}

export interface IManualMatchingStatus {
  id?: string;
  campaignId: string;
  creatorId: string;
  ctaTemplateId: string;
  socialContentId: string;
  status?: EManualMatchingStatus | null;
  processed: boolean;
}

export interface IManualMatchingStatusFetchParams {
  campaignId: string;
  creatorId: string;
  ctaTemplateIds: string[];
  socialContentId: string;
  campaignExportId?: string | null;
}

export interface IManualMatchingStatusContext {
  campaignId: string;
  creatorId: string;
  socialContentId: string | null;
}

export interface IMatchingActionsVisibleParams {
  adminMode: boolean;
  creatorBriefingMode: boolean;
  exportMode: boolean;
  campaignExport: ICampaignExportApi | null;
  campaignIsLive: boolean;
  campaignProcessStatus: EProcessStatus;
}

export interface IMatchingSubheaderVisibleParams {
  creatorBriefingMode: boolean;
  exportMode: boolean;
  campaignExport: ICampaignExportApi | null;
}
